import { createSlice } from '@reduxjs/toolkit';

import { requestFailedMatcher } from '../request-failed/reducer';
import {
  type ISearchState,
  type SearchPageQuery,
  type SearchPageQueryResponse,
  type SearchQuery,
  type SearchQueryResponse,
} from './types';

const initialState: ISearchState = {
  query: '',
  products: [],
  isLoadingPage: false,
  pageQuery: '',
  pageProducts: [],
  page: 1,
  pages: 1,
  total: 0,
  unavailable: false,
};

const searchSlice = createSlice({
  name: 'Search',
  initialState,
  reducers: {
    clearResults: (state): void => {
      state.query = '';
      state.products = [];
      state.unavailable = false;
    },
    query: (state, action: SearchQuery): void => {
      state.query = action.payload.query;
    },
    queryResponse: (state, action: SearchQueryResponse): void => {
      if (action.payload.query === state.query) {
        state.unavailable = action.payload.unavailable ?? false;
        state.products = action.payload.products;
        state.products.forEach((product) => {
          product.photos.sort((a, b) => a.position - b.position);
        });
      }
    },
    queryPage: (state, action: SearchPageQuery): void => {
      state.isLoadingPage = true;
      state.pageQuery = action.payload.query;
      state.pageStock = action.payload.stock;
    },
    queryPageResponse: (state, action: SearchPageQueryResponse): void => {
      state.isLoadingPage = false;

      if (
        action.payload.query !== state.pageQuery ||
        action.payload.stock !== state.pageStock
      ) {
        return;
      }

      state.unavailable = action.payload.unavailable ?? false;
      state.pageProducts = action.payload.products;
      state.pageProducts.forEach((product) => {
        product.photos.sort((a, b) => a.position - b.position);
      });
      state.page = action.payload.page;
      state.pages = action.payload.pages;
      state.total = action.payload.total;
    },
  },
  extraReducers: (builder): void => {
    builder.addMatcher(requestFailedMatcher('Search'), (state): void => {
      state.isLoadingPage = false;
    });
  },
});

export const {
  clearResults,
  query,
  queryResponse,
  queryPage,
  queryPageResponse,
} = searchSlice.actions;

export default searchSlice.reducer;
